import { Injectable } from "@angular/core";
import * as momentTz from "moment-timezone";
import * as moment from "moment";
import * as CryptoJS from 'crypto-js';
import { convertToLocalDate } from '../helpers/convert-to-local-date.helper';

@Injectable({ providedIn: 'root' })
export class TimeZoneService {

    private encryptSecretKey = "LionO3602.0CRM2021";

    showDateTimeWithZone(date, userZone: boolean = true) {
        if (date && typeof date === 'string') {
            date = convertToLocalDate(date);
            const dateStr = date + '';
            if (!dateStr.endsWith('Z')) {
                date = date + 'Z';
            }
        }

        let newDate = new Date(date);
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData?.timeZone && userZone) {
            const mDate = momentTz.tz(newDate, sessionData.timeZone.IANATimeZone);
            const timezonedDate = mDate.tz(sessionData.timeZone.IANATimeZone).format('MM/DD/YYYY h:m A')
            return new Date(timezonedDate);
        }

        const dateStr = date + '';
        if (dateStr.endsWith('Z')) {
            date = date.replace(/^Z+|Z+$/g, '');
            newDate = new Date(date);
        }

        return newDate;
    }

    saveDateTimeWithZone(date: string|Date) {
        let userGMT = this.getUserGMT();
        date = date + '';
        date = date.split('GMT')[0];
        date = date.concat(` ${userGMT}`)
        const dateObj = new Date(date).toUTCString();
        return new Date(dateObj);
    }

    getUserGMT() {
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        const mDate = moment.tz(sessionData.timeZone.IANATimeZone).format('Z');
        return `GMT${mDate}`; //It will give automatic daylight saving or not
    }

    decode(data) {
        const decrypted = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (decrypted) {
            try {
                const str = decrypted.toString(CryptoJS.enc.Utf8);
                if (str.length > 0) {
                    return JSON.parse(str);
                } else {
                    return 'error 1';
                }
            } catch (e) {
                return 'error 2';
            }
        }
        return 'error 3';
    }

    getUserTimezoneName(){
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        return sessionData?.timeZone?.Name||null;
    }

    getUserIANATimeZone(){
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        return sessionData?.timeZone?.IANATimeZone||null;
    }

    getUserTimeZoneDescription(){
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        return sessionData?.timeZone?.Description||null;
    }

    _getUTCDateTimeWithZone(date: string | Date, userZone: boolean = true,  clearTime: boolean = true, convertToTimezone: boolean = true): Date {
        if (date && typeof date === 'string') {
            date = convertToLocalDate(date);
            const dateStr = date + '';
            if (!dateStr.endsWith('Z')) {
                date = date + 'Z';
            }
        }
        const fmt   = "MM/DD/YYYY h:mm:ss A";
        let newDate = new Date(date);
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone && convertToTimezone) { //converting local time user timezone
            const mDate = momentTz.tz(newDate, sessionData.timeZone.IANATimeZone);
            const timezonedDate = mDate.tz(sessionData.timeZone.IANATimeZone).format(fmt)
            newDate = new Date(timezonedDate);
        }

        if(clearTime){ //If need beggining of that day
            newDate.setHours(0, 0, 0, 0);
        }

        const input = moment(newDate).format(fmt);
        const zone  = sessionData?.timeZone?.IANATimeZone||'UTC';
        const timezonedDate = userZone ? moment.tz(input, fmt, zone).utc().format(fmt) : input; //converting user time to UTC (Database time)
        return new Date(timezonedDate);
    }

    _getUTCDateTimeString(date: Date){
        let tString = `${moment(date).format("YYYY-MM-DDTHH:mm:ss")}.000Z`;
        return tString;
    }

    _getCustomDateString(date: Date|string){
        if(!date) return "";

        date = new Date(date);
        let tString = `${moment(date).format("YYYY-MM-DDT00:00:00")}`;
        return tString;
    }

    _getCustomDateTimeString(date: Date|string){
        if(!date) return "";

        date = new Date(date);
        let tString = `${moment(date).format("YYYY-MM-DDTHH:mm:ss")}.000Z`;
        return tString;
    }

    formateToUserDate(date: any, format?: 'date' | 'MM-DD-YYYY' | 'MM/DD/YYYY' | 'h:mm a' | 'MM/DD/YYYY | h:mm a', userZone: boolean = true): any {
        let checkDate = Date.parse(date);
        date = convertToLocalDate(date);
        if (date === '' || date === null || isNaN(checkDate) == true) {
            return '';
        }
        if (format == 'date') {
            format = 'MM/DD/YYYY';
        }
        const dateStr = date + '';
        if (!dateStr.endsWith('Z')) {
            date = date + 'Z';
        }
        const dateFormat = format ? format : 'MM/DD/YYYY | h:mm a';
        let newDate = new Date(date);
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone && userZone) {
            const mDate = momentTz.tz(newDate, sessionData.timeZone.IANATimeZone);
            const timezonedDate = mDate.tz(sessionData.timeZone.IANATimeZone).format(dateFormat)
            return timezonedDate;
        }

        if (dateStr.endsWith('Z')) {
            date = date.replace(/^Z+|Z+$/g, '');
            newDate = new Date(date);
        }

        return moment(newDate).format(dateFormat);
    }

    convertToLocalDate(date: string | Date) {

        if ((typeof date !== 'string')) {
            date = new Date(date).toISOString();
        }

        if ((typeof date === 'string') && date?.endsWith('Z')) {
            date = date.replace('Z', '');
            date = date.replace('T', ' ');
        }
        return new Date(date);
    }

    onlyTime(time: string){
        if(!time) return null;
        return moment(time,'HH:mm').format('h:mm A');
    }
}
